import { Styles } from '@monkvision/types';

export const styles: Styles = {
  notCarPart: {
    display: 'none',
  },
  selectable: {
    pointerEvents: 'fill',
    cursor: 'pointer',
  },
};
